/*
 * Translations object for zonar-ui/core component.
 * Give each language an object whose key corresponds with the language identifier.
 * Every translation must include all the en-US properties (translations)
 */

export const supportedLanguages = ['en-US', 'en-GB', 'it', 'fr-FR', 'de', 'es-ES'];
export const defaultLanguage = 'en-US';
export const genericLanguageMap = [
  {
    languageAbbreviation: 'es',
    useLanguage: 'es-ES'
  },
  {
    languageAbbreviation: 'fr',
    useLanguage: 'fr-FR'
  }
];
export const translations = {
  'en-US': {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Support Phone',  // Not currently implemented, but translations preserved in this file against future use
      supportConti: 'Contact Us',
      supportLink: 'Support',
      termsAndConditionsLink: 'Terms & Conditions',
      dataDisclosureLink: 'Data Disclosure'
    },
    userMenu: {
      login: 'Login',
      logout: 'Logout',
      selectCompany: 'Select Company'
    },
    selectCompany: {
      selectCompany: 'Select Company',
      company: 'Company',
      placeholder: 'Search companies',
      done: 'Done'
    }
  },
  de: {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Telefonsupport',
      supportConti: 'Kontaktieren Sie uns',
      supportLink: 'Support',
      termsAndConditionsLink: 'Geschäftsbedingungen',
      dataDisclosureLink: 'Offenlegung von Daten'
    },
    userMenu: {
      login: 'Anmelden',
      logout: 'Abmelden',
      selectCompany: 'Unternehmen auswählen'
    },
    selectCompany: {
      selectCompany: 'Unternehmen auswählen',
      company: 'Unternehmen',
      placeholder: 'Unternehmen suchen',
      done: 'Fertig'
    }
  },
  'es-ES': {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Teléfono de contacto',
      supportConti: 'Contáctenos',
      supportLink: 'Soporte',
      termsAndConditionsLink: 'Términos y condiciones',
      dataDisclosureLink: 'Divulgación de datos'
    },
    userMenu: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      selectCompany: 'Seleccionar empresa'
    },
    selectCompany: {
      selectCompany: 'Seleccionar empresa',
      company: 'Empresa',
      placeholder: 'Buscar empresas',
      done: 'Hecho'
    }
  },
  'fr-FR': {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Téléphone de l’assistance',
      supportConti: 'Nous contacter',
      supportLink: 'Assistance',
      termsAndConditionsLink: 'Conditions générales',
      dataDisclosureLink: 'Divulgation des données'
    },
    userMenu: {
      login: 'Connexion',
      logout: 'Déconnexion',
      selectCompany: 'Sélectionner une entreprise'
    },
    selectCompany: {
      selectCompany: 'Sélectionner une entreprise',
      company: 'Entreprise',
      placeholder: 'Rechercher une entreprise',
      done: 'Terminé'
    }
  },
  it: {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Telefono assistenza',
      supportConti: 'Contattaci',
      supportLink: 'Assistenza',
      termsAndConditionsLink: 'Termini e condizioni',
      dataDisclosureLink: 'Divulgazione dei dati'
    },
    userMenu: {
      login: 'Accedi',
      logout: 'Disconnetti',
      selectCompany: 'Seleziona azienda'
    },
    selectCompany: {
      selectCompany: 'Seleziona azienda',
      company: 'Azienda',
      placeholder: 'Cerca aziende',
      done: 'Fatto'
    }
  },
  'en-GB': {
    footer: {
      zonarSystems: 'Zonar Systems',
      // supportPhone: 'Support phone no.',
      supportConti: 'Contact Us',
      supportLink: 'Support',
      termsAndConditionsLink: 'Terms & Conditions',
      dataDisclosureLink: 'Data disclosure'
    },
    userMenu: {
      login: 'Login',
      logout: 'Logout',
      selectCompany: 'Select company'
    },
    selectCompany: {
      selectCompany: 'Select company',
      company: 'Company',
      placeholder: 'Search companies',
      done: 'Done'
    }
  }
};
